import Axios from 'axios'
const p = (path = '') => `${window.$ApiHost}/bls/${path ? path + '/' : path}`

const state = {
  reports: [],
  reportsQueryParams: {
    limit: 40,
    page: 1,
  },
}

const mutations = {
  SET_REPORTS(state, { results, limit, page }) {
    state.reportsQueryParams.limit = limit || state.reportsQueryParams.limit
    state.reportsQueryParams.page = page || state.reportsQueryParams.page
    state.reports = results
  },
}

const actions = {
  async fetchReports({ commit, state }, params = state.reportsQueryParams) {
    let response
    try {
      response = await Axios.get(p('reports'), { params })
      commit('SET_REPORTS', { ...response.data, ...params })
    } catch (error) {
      response = error.response
    }
    return response
  },
  async reportStatusChange({ commit }, data) {},
  async fetchReportItem({ commit }, id) {
    let response
    try {
      response = await Axios(p(`reports/${id}`))
    } catch (error) {
      response = error.response
    }
    return response
  },
  async getMessagesByReport({ commit }, id) {
    let response
    try {
      response = await Axios.get(p(`reports/${id}/messages`))
    } catch (error) {
      response = error.response
    }
    return response
  },
  async sendMessage({ commit }, message) {
    let response
    try {
      response = await Axios.post(p('reports/send-message'), message)
    } catch (error) {
      response = error.response
    }
    return response
  },
  async changeStatus({ commit }, { status, blsID }) {
    let response
    try {
      response = await Axios.put(p(`reports/${blsID}/status`), { status })
    } catch (error) {
      response = error.response
    }
    return response
  },
  // eslint-disable-next-line camelcase
  async getSvcBls(_, { bls_id = [] }) {
    let response
    try {
      response = await Axios.post(p('reports/export'), { bls_id })

      const blob = new Blob([response.data])
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `bls-${new Date()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    } catch (error) {
      response = error?.response
    }
    return response
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
